export default __webpack_public_path__ + "static/media/file1.b46686e6.png";